module.exports = __webpack_public_path__ + "static/img/career-course-image3.8afc8194.png";